/** Contract Consultant lives on /ai-chat and is free for all authenticated users. */
export function isAiChatRoute(pathname: string): boolean {
  return pathname === "/ai-chat";
}
